// extracted by mini-css-extract-plugin
module.exports = {"logo":"LandingPage_logo__w1uvn","search-area":"LandingPage_search-area__2pb8L","landing":"LandingPage_landing__3fU-u"};